import { isAxiosError } from 'axios';
import { queryClient } from '~/lib/react-query';
import { CURRENT_USER_PROFILE_QUERY_KEY } from '~/hooks/useCurrentUserProfile';
import keycloak from '~/shared/guards/Keycloak';

export function clearClientAuthState(): void {
  queryClient.removeQueries({ queryKey: [...CURRENT_USER_PROFILE_QUERY_KEY] });
}

/** Clears cached profile/permissions then ends the Keycloak session. */
export function logoutApp(): void {
  clearClientAuthState();
  keycloak.logout();
}

export function getAxiosStatus(error: unknown): number | undefined {
  if (isAxiosError(error)) {
    return error.response?.status;
  }
  return undefined;
}
